var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SmartChurchLayout',[_c('v-container',[_c('ul',_vm._l((_vm.activityLogs),function(log){return _c('li',{key:log.id},[_vm._v(" "+_vm._s(log.action)+" - "+_vm._s(log.timestamp)+" "+_vm._s(log)+" ")])}),0)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }